export { CategoryBrowsePopularFormats } from './CategoryBrowsePopularFormats';
import { CategoryBrowsePopularFormats } from './CategoryBrowsePopularFormats';

export default CategoryBrowsePopularFormats;
